import { useEffect } from 'react';

let locks = 0;
let previous = { overflow: '', paddingRight: '' };

/**
 * Locks page scroll while `active`. Ref-counted: nested overlays release only on the last close.
 * The hidden scrollbar's width is padded back so the page never shifts (ST7 R6).
 */
export default function useScrollLock(active) {
  useEffect(() => {
    if (!active) return undefined;
    if (locks === 0) {
      const { style } = document.body;
      previous = { overflow: style.overflow, paddingRight: style.paddingRight };
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar > 0) style.paddingRight = `calc(${getComputedStyle(document.body).paddingRight} + ${scrollbar}px)`;
      style.overflow = 'hidden';
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) Object.assign(document.body.style, previous);
    };
  }, [active]);
}
